import React from 'react';
import { Heading } from "@paro.io/base-ui";

export default function () {
  return (
    <Heading size="h1" className="text-center md:px-10">
      Apply to join our elite network of remote finance and accounting experts
    </Heading>
  )
}
